import React, { CSSProperties } from 'react'
import * as ModalPrimitive from '@radix-ui/react-dialog';
import * as S from './styles';

type ModalProps = React.ComponentProps<typeof ModalPrimitive.Root> & {
  affectedBySidebar?: string;
  // eslint-disable-next-line no-unused-vars
  onOpenChange?: (open: boolean) => void;
  preventToastClose?: boolean;
}

export function Modal({ children, onOpenChange, preventToastClose = false, ...props }: ModalProps) {
  function handleOpenChange(open: boolean) {
    // Se está tentando fechar o modal e temos proteção contra toasts ativada
    if (!open && preventToastClose) {
      // Verificar se há toasts visíveis
      const toastElements = document.querySelectorAll('.Toastify__toast');
      if (toastElements.length > 0) {
        // Não fechar o modal se há toasts visíveis
        return;
      }
    }
    
    // Chamar o handler original se fornecido
    if (onOpenChange) {
      onOpenChange(open);
    }
  }

  return (
    <ModalPrimitive.Root onOpenChange={handleOpenChange} {...props}>
      {children}
    </ModalPrimitive.Root>
  )
}

 type ModalContentProps = ModalPrimitive.DialogContentProps &
  React.ComponentProps<typeof S.ModalPrimitiveContent> & {
    overlayStyle?:CSSProperties;
    contentStyle?:CSSProperties;
    preventToastClose?: boolean;
 }

const visuallyHiddenStyle: CSSProperties = { position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', borderWidth: 0 }

export function ModalContent({ children, preventToastClose = true, overlayStyle, contentStyle, ...props  }:  ModalContentProps & ModalPrimitive.DialogContentProps & React.ComponentProps<typeof S.ModalPrimitiveContent>) {
  function handleOpenAutoFocus(event: Event){
    event.preventDefault();
  }

  function handleClose(){
    props.onClose && props.onClose()
  }

  function handleInteractOutside(event: Event) {
    const target = event.target as HTMLElement;

    // Verifica se o clique foi em um toast ou seus descendentes
    const isToastClick = target.closest('.Toastify__toast-container') !== null ||
                        target.closest('.Toastify__toast') !== null ||
                        target.className.includes('Toastify') ||
                        target.closest('#toast-portal-root') !== null;

    if (isToastClick && preventToastClose) {
      // Prevenir o fechamento do modal se clicou em um toast
      event.preventDefault();
      return;
    }
  }

  function handleOverlayClick(event: React.MouseEvent) {
    const target = event.target as HTMLElement;

    // Verifica se o clique foi em um toast ou seus descendantes
    const isToastClick = target.closest('.Toastify__toast-container') !== null ||
                        target.closest('.Toastify__toast') !== null ||
                        target.className.includes('Toastify');

    if (isToastClick) {
      // Não fechar o modal se o clique foi em um toast
      event.stopPropagation();
      return;
    }

    // Verifica se o clique foi no próprio overlay (não em filhos)
    if (event.target === event.currentTarget) {
      handleClose();
    }
  }

  return (
    <>
      <S.DialogOverlay style={overlayStyle} onClick={handleOverlayClick} />
      <S.ModalPrimitiveContent
        style={contentStyle}
        affectedBySidebar={props.affectedBySidebar}
        onOpenAutoFocus={handleOpenAutoFocus}
        onInteractOutside={handleInteractOutside}
        aria-describedby={undefined}
        {...props}
      >
        <ModalPrimitive.Title style={visuallyHiddenStyle}>Modal</ModalPrimitive.Title>
        {children}
      </S.ModalPrimitiveContent>
    </>
  )
}

export const ModalTrigger = ModalPrimitive.Trigger;
ModalTrigger.displayName = 'ModalTrigger';

export const ModalClose = ModalPrimitive.Close;
ModalClose.displayName = 'ModalClose';

